// Electric Current units with conversion factors to ampere (A)
export const currentUnits = [
  { id: 'ampere', name: 'Ampere', symbol: 'A', plural: 'Amperes', factor: 1 },
  { id: 'kiloampere', name: 'Kiloampere', symbol: 'kA', plural: 'Kiloamperes', factor: 1e3 },
  { id: 'milliampere', name: 'Milliampere', symbol: 'mA', plural: 'Milliamperes', factor: 1e-3 },
  { id: 'microampere', name: 'Microampere', symbol: 'µA', plural: 'Microamperes', factor: 1e-6 },
  { id: 'nanoampere', name: 'Nanoampere', symbol: 'nA', plural: 'Nanoamperes', factor: 1e-9 },
  { id: 'picoampere', name: 'Picoampere', symbol: 'pA', plural: 'Picoamperes', factor: 1e-12 },
  { id: 'abampere', name: 'Abampere', symbol: 'abA', plural: 'Abamperes', factor: 10 },
  { id: 'statampere', name: 'Statampere', symbol: 'statA', plural: 'Statamperes', factor: 3.335641e-10 },
  { id: 'coulomb-per-second', name: 'Coulomb/Second', symbol: 'C/s', plural: 'Coulombs/Second', factor: 1 },
  { id: 'biot', name: 'Biot', symbol: 'Bi', plural: 'Biots', factor: 10 },
  { id: 'gilbert', name: 'Gilbert', symbol: 'Gi', plural: 'Gilberts', factor: 0.795774715 },
];

export const popularCurrentConversions = [
  { from: 'ampere', to: 'milliampere' },
  { from: 'milliampere', to: 'ampere' },
  { from: 'ampere', to: 'microampere' },
  { from: 'ampere', to: 'kiloampere' },
  { from: 'milliampere', to: 'microampere' },
  { from: 'ampere', to: 'abampere' },
];

export const getUnitById = (id) => currentUnits.find(unit => unit.id === id);

export const convertCurrent = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert electric current units and learn the conversion formula.`;
};
